import React from 'react'
import PropTypes from 'prop-types'
import {Box, Input, InputRightElement, Text, useMultiStyleConfig} from '@chakra-ui/react'
import {CheckIcon, InfoIcon} from '../icons'
import InfoPopover from '../popovers/info-popover'

const InputComponent = React.forwardRef((props, ref) => {
    const {
        isSuccess,
        isInvalid,
        tooltip,
        tooltipVariant,
        tooltipOpensOn,
        isProductRegistration,
        name,
        fillText,
        shouldRemoveLabel,
        value,
        rules,
        variant,
        hideSuccessIcon,
        placeholder = '',
        ...rest
    } = props

    let status = isSuccess
        ? 'success'
        : isInvalid
        ? 'invalid'
        : props.isDisabled
        ? 'disabled'
        : undefined

    const styles = useMultiStyleConfig('Field', {
        variant: status,
        shouldRemoveLabel,
        isProductRegistration,
    })
    const onChangeInProps = typeof onChange === 'function'

    return (
        <Box __css={styles.container}>
            <Input
                ref={ref}
                {...rest}
                {...styles.input}
                value={onChangeInProps ? fillText : value}
                placeholder={placeholder}
                _disabled={{
                    borderColor: props.value && props.value.length > 0 ? props.borderColor : 'grey',
                }}
                autoComplete="off"
            />
            <Text as="label" htmlFor={name} className="chakra-form__label" {...styles.label}>
                {props.label}
                {variant !== 'productRegistration' && rules?.required && ' *'}
            </Text>
            {isSuccess && (
                <InputRightElement {...styles.inputRightElement}>
                    <CheckIcon
                        {...{...styles.successIcon, display: hideSuccessIcon ? 'none' : 'block'}}
                    />
                </InputRightElement>
            )}
            {tooltip && (
                <InputRightElement {...styles.inputRightElement}>
                    <InfoPopover
                        trigger={
                            <Box>
                                <InfoIcon {...styles.infoIcon} />
                            </Box>
                        }
                        variant={tooltipVariant}
                        openTooltipOn={tooltipOpensOn}
                    />
                </InputRightElement>
            )}
        </Box>
    )
})

InputComponent.displayName = 'InputComponent'
InputComponent.propTypes = {
    label: PropTypes.string,
    inputProps: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
    inputType: PropTypes.string,
    isDisabled: PropTypes.bool,
    isInvalid: PropTypes.bool,
    tooltip: PropTypes.string,
    tooltipVariant: PropTypes.string,
    tooltipOpensOn: PropTypes.string,
    isSuccess: PropTypes.bool,
    isRequired: PropTypes.bool,
    name: PropTypes.string,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    onFocus: PropTypes.func,
    placeholder: PropTypes.string,
    variant: PropTypes.string,
    sx: PropTypes.object,
    fillText: PropTypes.string,
    shouldRemoveLabel: PropTypes.bool,
    value: PropTypes.string,
    rules: PropTypes.object,
    isProductRegistration: PropTypes.bool,
    'aria-label': PropTypes.string,
    borderColor: PropTypes.string,
    hideSuccessIcon: PropTypes.bool,
}

export default InputComponent
